













import { defineComponent } from '@nuxtjs/composition-api'
import { useConfig } from '~/composables';
export default defineComponent({
    setup() {
        const {config: storeConfig} = useConfig();
        return {
            storeCode: storeConfig.value?.store_code
        }
    }
})
